var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartFinderNoProductTypes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 192,
    viewBox: "0 0 226 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product Type"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company settings - Add Part Finder Family"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1010108696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.93839 77.7792C9.26037 86.5396 18.698 91.758 27.4073 97.1644C36.1162 102.57 45.0292 109.262 47.9738 119.08C52.2078 133.196 42.6553 148.901 47.4865 162.824C51.688 174.933 66.0796 181.254 78.7917 179.614C91.5038 177.975 102.566 170.088 111.741 161.138C120.917 152.188 128.823 141.93 138.648 133.699C152.813 121.833 170.245 114.75 186.911 106.771C199.174 100.901 211.694 93.9861 219.061 82.5603C224.711 73.7985 226.764 62.6593 224.02 52.6014C221.276 42.5434 213.599 33.8267 203.758 30.3839C188.507 25.0482 171.948 32.4697 157.928 40.5027C143.909 48.5358 128.959 57.703 112.897 55.945C96.8096 54.1846 84.0376 41.8877 68.9472 36.0401C52.4433 29.6448 32.2803 32.5639 15.7121 37.9055C0.134376 42.9272 -4.00189 64.7093 3.93839 77.7792Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M188.056 20.4491C193.604 21.2333 199.151 22.0181 204.699 22.8023C206.527 23.061 208.468 23.3059 210.159 22.5633C213.296 21.1862 214.157 16.8207 212.749 13.6974C211.341 10.5737 208.351 8.48637 205.371 6.79418C201.482 4.58519 197.304 2.7541 192.873 2.1367C188.443 1.51931 183.72 2.20738 180.002 4.69365C177.222 6.55222 172.678 11.9414 174.474 15.5943C176.25 19.2074 184.694 19.9735 188.056 20.4491Z",
    fill: "#969696"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47.1632 24.186C47.1622 24.186 47.1617 24.1865 47.1608 24.1865L47.0479 24.211L46.963 23.8311L47.0719 23.8076C47.0729 23.8076 47.0744 23.8071 47.0744 23.8071C47.9313 23.6157 48.7656 23.3355 49.5543 22.9728L49.7241 23.3242C48.9094 23.6986 48.0481 23.9887 47.1632 24.186ZM44.2372 24.4966C43.2934 24.4878 42.3497 24.3739 41.4314 24.1575L41.5247 23.7796C42.4135 23.9892 43.3273 24.0996 44.2411 24.1079L44.2372 24.4966ZM52.1279 21.8725L51.8815 21.5672C52.5976 21.0165 53.2518 20.3844 53.8255 19.688L54.1362 19.9319C53.5428 20.6509 52.867 21.3041 52.1279 21.8725ZM38.7754 23.2118C37.9307 22.801 37.1327 22.2965 36.4029 21.7125L36.6552 21.4121C37.3619 21.9775 38.1344 22.4663 38.9525 22.8643L38.7754 23.2118ZM55.6497 17.6027L55.2915 17.4324C55.6924 16.629 56.0001 15.7819 56.2058 14.9137L56.594 15.0011C56.3815 15.8977 56.0635 16.7733 55.6497 17.6027ZM34.4334 19.7341C33.8558 19.0048 33.3631 18.2108 32.969 17.374L33.3307 17.2115C33.712 18.0218 34.189 18.7904 34.748 19.4961L34.4334 19.7341ZM56.9154 12.2591H56.5174C56.5174 11.3713 56.4139 10.4786 56.2097 9.60451L56.5979 9.51813C56.8085 10.4202 56.9154 11.3423 56.9154 12.2591ZM32.4748 14.6742L32.0851 14.7542C31.8907 13.8492 31.8009 12.9256 31.8186 12.0078L32.2166 12.0152C32.1999 12.9035 32.2868 13.7982 32.4748 14.6742ZM55.4922 7.47993C55.1261 6.66279 54.6638 5.88589 54.118 5.16984L54.4375 4.93771C55.0009 5.67731 55.4785 6.48022 55.8568 7.32386L55.4922 7.47993ZM32.5788 9.36648L32.1926 9.27176C32.4222 8.37903 32.7565 7.50987 33.1854 6.68782L33.5402 6.8645C33.1245 7.66054 32.8011 8.50222 32.5788 9.36648ZM52.2477 3.22097C51.5517 2.64283 50.7881 2.14077 49.9778 1.72803L50.1619 1.38301C50.9986 1.809 51.7873 2.32775 52.5058 2.92454L52.2477 3.22097ZM35.0484 4.63539L34.7426 4.38607C35.3483 3.67837 36.0358 3.03791 36.7867 2.48186L37.0277 2.79154C36.3009 3.32992 35.6349 3.95026 35.0484 4.63539ZM47.4243 0.766103C46.5394 0.540837 45.6276 0.413725 44.7147 0.388695L44.726 0C45.6688 0.0260112 46.6106 0.157048 47.5249 0.389676L47.4243 0.766103ZM39.381 1.42865L39.2175 1.07382C39.9684 0.744999 40.7591 0.486851 41.5684 0.306245C41.6847 0.280234 41.7961 0.257167 41.9099 0.234592L41.988 0.615926C41.8776 0.637029 41.7593 0.655187 41.6572 0.685125C40.8734 0.860332 40.1078 1.11063 39.381 1.42865Z",
    fill: "#2E363D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M61.0627 15.5028C61.5284 17.4914 60.2539 19.4722 58.2167 19.9267C56.1795 20.3811 54.1506 19.137 53.6848 17.1484C53.2191 15.1597 54.4936 13.179 56.5309 12.7245C58.5681 12.27 60.5969 13.5137 61.0627 15.5028Z",
    fill: "#2E363D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M186.194 38.214C186.194 39.7173 184.946 40.9359 183.406 40.9359C181.867 40.9359 180.618 39.7173 180.618 38.214C180.618 36.7108 181.866 35.4922 183.406 35.4922C184.946 35.4922 186.194 36.7108 186.194 38.214Z",
    fill: "#2E363D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M94.252 33.2133C95.9019 33.2133 97.2394 31.9076 97.2394 30.2971C97.2394 28.6865 95.9019 27.3809 94.252 27.3809C92.6021 27.3809 91.2646 28.6865 91.2646 30.2971C91.2646 31.9076 92.6021 33.2133 94.252 33.2133Z",
    fill: "#2E363D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M99.6294 39.2385C99.3928 39.2385 99.1553 39.2233 98.9232 39.1938L98.9747 38.8086C99.8601 38.9219 100.776 38.8007 101.598 38.4552L101.756 38.812C101.083 39.0952 100.368 39.2385 99.6294 39.2385ZM96.2897 38.1038C95.528 37.5139 94.944 36.735 94.6004 35.8516L94.9724 35.7137C95.2904 36.5314 95.8318 37.2528 96.5375 37.799L96.2897 38.1038ZM103.987 37.0658L103.664 36.8376C104.191 36.127 104.511 35.2897 104.589 34.4161L104.986 34.45C104.902 35.3933 104.556 36.2978 103.987 37.0658ZM94.6505 33.9896H94.252C94.252 33.04 94.5145 32.109 95.0117 31.2982L95.3537 31.498C94.8934 32.2484 94.6505 33.1097 94.6505 33.9896ZM104.113 31.8734C103.721 31.0847 103.118 30.4124 102.367 29.9289L102.586 29.6045C103.397 30.1267 104.048 30.8526 104.471 31.7041L104.113 31.8734ZM97.2668 29.7101L97.0774 29.368C97.9249 28.9209 98.908 28.704 99.865 28.7452L99.8473 29.1334C98.9634 29.0966 98.0516 29.2963 97.2668 29.7101Z",
    fill: "#2E363D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M189.519 48.6276C188.554 48.5574 187.633 48.2978 186.781 47.8561L186.967 47.513C187.771 47.9292 188.639 48.1736 189.548 48.2399L189.519 48.6276ZM192.344 48.2679L192.213 47.9013C193.07 47.6088 193.844 47.1538 194.513 46.5477L194.784 46.8323C194.074 47.4753 193.253 47.9582 192.344 48.2679ZM184.589 46.078C183.987 45.3389 183.555 44.5026 183.307 43.5932L183.693 43.4936C183.926 44.3505 184.333 45.1387 184.901 45.8356L184.589 46.078ZM196.435 44.565L196.07 44.4094C196.433 43.5986 196.617 42.7353 196.617 41.8421H197.016C197.015 42.7893 196.82 43.7051 196.435 44.565ZM196.579 41.1428C196.48 40.2589 196.201 39.4206 195.747 38.6501L196.093 38.4567C196.574 39.2744 196.871 40.1637 196.975 41.1015L196.579 41.1428ZM183.547 40.8753L183.153 40.8174C183.297 39.8854 183.632 39.0089 184.149 38.2104L184.486 38.4185C183.999 39.1703 183.683 39.9973 183.547 40.8753ZM193.962 36.6899C193.23 36.1584 192.409 35.7884 191.524 35.5896L191.613 35.2107C192.552 35.4218 193.423 35.8144 194.199 36.3778L193.962 36.6899ZM186.354 36.5329L186.13 36.2119C186.93 35.6804 187.817 35.3241 188.765 35.1523L188.838 35.5342C187.944 35.6966 187.108 36.0323 186.354 36.5329Z",
    fill: "#2E363D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M118.388 157.703H80.5566V170.65C93.0337 167.806 105.697 165.449 118.388 163.26V157.703Z",
    fill: "#969696",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M80.5566 170.65V184.054H118.388V163.26C105.697 165.449 93.0337 167.807 80.5566 170.65Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M144.765 190.828H54.18C53.5676 190.828 53.4296 189.969 54.0117 189.777L80.5569 181.041H118.388L144.934 189.777C145.515 189.969 145.377 190.828 144.765 190.828Z",
    fill: "#5C5C5C",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M114.097 181.041H117.491",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M80.5566 181.041H110.607",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M173.742 160.61H25.1562C21.6123 160.61 18.7393 157.737 18.7393 154.193V56.0556C18.7393 52.5117 21.6123 49.6387 25.1562 49.6387H173.742C177.286 49.6387 180.159 52.5117 180.159 56.0556V154.193C180.159 157.737 177.286 160.61 173.742 160.61Z",
    fill: "#DEDEDE",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M18.7393 149.199V154.193C18.7393 157.737 21.6123 160.61 25.1562 160.61H173.742C177.286 160.61 180.159 157.737 180.159 154.193V149.199H18.7393Z",
    fill: "#5C5C5C",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M24.4756 143.17V55.6623C24.4756 55.1068 24.9261 54.6562 25.4817 54.6562H173.415C173.971 54.6562 174.421 55.1068 174.421 55.6623V143.17C174.421 143.726 173.971 144.176 173.415 144.176H25.4817C24.9261 144.176 24.4756 143.726 24.4756 143.17Z",
    fill: "white",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M102.084 154.08C102.084 155.535 100.905 156.715 99.4494 156.715C97.9943 156.715 96.8145 155.535 96.8145 154.08C96.8145 152.625 97.9943 151.445 99.4494 151.445C100.905 151.445 102.084 152.625 102.084 154.08Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M113.396 69.5944L115.819 74.2464H140.754C141.471 74.2464 142.051 74.827 142.051 75.5436V108.291C142.051 109.008 141.471 109.588 140.754 109.588H92.9299C92.2134 109.588 91.6328 109.008 91.6328 108.291V76.6782V74.2464V70.1936C91.6328 69.4776 92.2134 68.8965 92.9299 68.8965H112.245C112.729 68.8965 113.173 69.1654 113.396 69.5944Z",
    fill: "#EDB837"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M125.878 94.5144C127.067 89.5217 123.983 84.5107 118.99 83.322C113.997 82.1334 108.986 85.2172 107.798 90.2099C106.609 95.2026 109.693 100.214 114.686 101.402C119.678 102.591 124.689 99.5071 125.878 94.5144Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M120.804 95.8206L117.348 92.3645L120.804 88.9085C120.943 88.7696 120.943 88.5419 120.804 88.403C120.665 88.2641 120.437 88.2641 120.298 88.403L116.842 91.8591L113.386 88.403C113.247 88.2641 113.019 88.2641 112.881 88.403C112.742 88.5419 112.742 88.7696 112.881 88.9085L116.337 92.3645L112.881 95.8206C112.742 95.9595 112.742 96.1872 112.881 96.3261C113.019 96.465 113.247 96.465 113.386 96.3261L116.842 92.87L120.298 96.3261C120.437 96.465 120.665 96.465 120.804 96.3261C120.943 96.1872 120.943 95.96 120.804 95.8206Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M170.258 69.5944L172.681 74.2464H197.616C198.333 74.2464 198.914 74.827 198.914 75.5436V108.291C198.914 109.008 198.333 109.588 197.616 109.588H149.792C149.076 109.588 148.495 109.008 148.495 108.291V76.6782V74.2464V70.1936C148.495 69.4776 149.076 68.8965 149.792 68.8965H169.108C169.591 68.8965 170.034 69.1654 170.258 69.5944Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M182.843 94.0786C183.788 89.0341 180.465 84.1783 175.421 83.2329C170.376 82.2875 165.52 85.6106 164.575 90.6551C163.63 95.6997 166.953 100.555 171.997 101.501C177.042 102.446 181.898 99.1231 182.843 94.0786Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M177.666 95.8206L174.21 92.3645L177.666 88.9085C177.805 88.7696 177.805 88.5419 177.666 88.403C177.527 88.2641 177.299 88.2641 177.16 88.403L173.704 91.8591L170.248 88.403C170.109 88.2641 169.882 88.2641 169.743 88.403C169.604 88.5419 169.604 88.7696 169.743 88.9085L173.199 92.3645L169.743 95.8206C169.604 95.9595 169.604 96.1872 169.743 96.3261C169.882 96.465 170.109 96.465 170.248 96.3261L173.704 92.87L177.16 96.3261C177.299 96.465 177.527 96.465 177.666 96.3261C177.805 96.1872 177.805 95.96 177.666 95.8206Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M56.5325 69.5944L58.9555 74.2464H83.8909C84.6074 74.2464 85.188 74.827 85.188 75.5436V108.291C85.188 109.008 84.6074 109.588 83.8909 109.588H36.0667C35.3501 109.588 34.7695 109.008 34.7695 108.291V76.6782V74.2464V70.1936C34.7695 69.4776 35.3501 68.8965 36.0667 68.8965H55.3822C55.8661 68.8965 56.3092 69.1654 56.5325 69.5944Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M69.0166 94.5144C70.2052 89.5217 67.1214 84.5107 62.1287 83.322C57.136 82.1334 52.125 85.2172 50.9364 90.2099C49.7478 95.2026 52.8316 100.214 57.8243 101.402C62.817 102.591 67.828 99.5071 69.0166 94.5144Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M63.9404 95.8206L60.4843 92.3645L63.9404 88.9085C64.0792 88.7696 64.0792 88.5419 63.9404 88.403C63.8015 88.2641 63.5737 88.2641 63.4349 88.403L59.9788 91.8591L56.5228 88.403C56.3839 88.2641 56.1561 88.2641 56.0173 88.403C55.8784 88.5419 55.8784 88.7696 56.0173 88.9085L59.4733 92.3645L56.0173 95.8206C55.8784 95.9595 55.8784 96.1872 56.0173 96.3261C56.1561 96.465 56.3839 96.465 56.5228 96.3261L59.9788 92.87L63.4349 96.3261C63.5737 96.465 63.8015 96.465 63.9404 96.3261C64.0792 96.1872 64.0797 95.96 63.9404 95.8206Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M92.085 157.334H167.673L175.655 73.3027H100.066L92.085 157.334Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M90.7178 157.062H166.307L173.061 70.8301H97.4718L90.7178 157.062Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M89.2949 154.279H166.011L171.637 68.0469H104.761L89.2949 154.279Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M104.086 66.1582H91.1074V75.2636V78.1214V157.253H166.696V66.1582H104.086Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M158.791 65.3306C158.755 66.0746 159.14 66.6979 159.652 66.723C160.164 66.749 160.608 66.1654 160.645 65.4209C160.68 64.6769 160.295 64.0531 159.784 64.0281C159.272 64.0036 158.828 64.5866 158.791 65.3306Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    opacity: 0.53,
    d: "M157.019 65.5762C157.29 66.3894 157.963 66.8983 158.522 66.7123C159.081 66.5263 159.316 65.7161 159.046 64.9033C158.775 64.0896 158.103 63.5812 157.544 63.7667C156.984 63.9527 156.749 64.763 157.019 65.5762Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M155.596 66.9814C155.187 68.1013 156.058 69.449 157.542 69.9903C159.025 70.5316 160.558 70.062 160.968 68.941C161.377 67.8206 160.505 66.4734 159.022 65.9321C157.539 65.3903 156.004 65.8604 155.596 66.9814Z",
    fill: "#121D30"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M154.03 66.8016C146.403 65.6336 135.199 70.8118 136.252 80.1866C137.003 86.8724 146.11 89.8942 148.961 83.3344C152.822 74.4528 140.845 72.6855 135.062 73.0914C128.418 73.5577 124.064 73.7486 116.467 82.4947C113.357 86.0744 112.578 99.8437 120.287 100.778",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeDasharray: "5.52 5.52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M68.8112 67.5078C66.2209 71.3167 70.7571 76.2515 74.2103 77.6983C82.1844 81.041 87.5128 72.8754 95.1556 73.6538C101.718 74.3218 105.787 78.7491 102.31 86.1043C100.155 90.6617 89.7482 91.975 90.1104 85.4217",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeDasharray: "5.52 5.52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M68.4798 61.9307C68.1181 62.582 67.4615 62.9073 67.0134 62.658C66.5653 62.4097 66.4956 61.6789 66.8583 61.0282C67.221 60.3774 67.8776 60.0515 68.3247 60.3003C68.7733 60.5501 68.8425 61.2794 68.4798 61.9307Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    opacity: 0.53,
    d: "M69.8552 63.0775C69.1956 63.6248 68.3559 63.7013 67.9795 63.2483C67.6025 62.7948 67.8312 61.9826 68.4904 61.4354C69.1495 60.8877 69.9892 60.8111 70.3661 61.2641C70.7435 61.7176 70.5143 62.5293 69.8552 63.0775Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M70.3206 65.0221C70.0762 66.1892 68.6245 66.8729 67.0791 66.5485C65.5336 66.2241 64.4799 65.0153 64.7248 63.8472C64.9692 62.6797 66.4214 61.9965 67.9664 62.3209C69.5118 62.6448 70.566 63.8546 70.3206 65.0221Z",
    fill: "#121D30"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M171.894 74.4699C171.894 74.4699 166.922 71.2381 163.984 75.0985C160.307 79.9312 168.951 84.2167 166.175 87.6482C163.398 91.0802 159.756 92.7699 160.956 98.5749C162.525 106.164 179.342 110.767 187.495 100.046C195.649 89.3252 186.962 79.2044 180.945 78.9703C173.705 78.6891 171.894 74.4699 171.894 74.4699Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M174.175 85.9542L176.751 92.1591C177.085 92.9625 177.714 93.5543 178.459 93.8626C179.202 94.1717 180.065 94.1968 180.869 93.8631C182.476 93.1956 183.236 91.3513 182.568 89.744L179.992 83.5391L174.175 85.9542Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M183.63 79.7778C183.878 81.0572 183.042 82.2955 181.763 82.5438C180.483 82.7921 179.245 81.9563 178.997 80.6769C178.748 79.3974 179.584 78.1592 180.864 77.9109C182.143 77.6625 183.381 78.4983 183.63 79.7778Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M182.689 79.1992L181.447 81.0848",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M171.113 84.4653C171.361 85.7447 170.525 86.983 169.245 87.2313C167.966 87.4796 166.728 86.6433 166.479 85.3644C166.231 84.0849 167.067 82.8467 168.346 82.5984C169.626 82.35 170.864 83.1858 171.113 84.4653Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M169 84.8291C169 84.8291 167.188 83.9835 166.283 80.5691L168.03 79.8438L169 84.8291Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M169.554 85.7269L167.184 84.791",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M170.926 74.043C167.796 75.3426 166.313 78.9336 167.612 82.0633L169.546 86.7198C169.594 86.8356 169.65 86.9445 169.712 87.051C170.023 87.5659 170.513 87.9555 171.099 88.1342L174.187 89.0897C175.123 89.3803 176.146 89.0878 176.79 88.3413L180.332 84.2394C180.941 83.5287 181.098 82.5379 180.741 81.678L178.947 77.3567C177.647 74.227 174.056 72.7434 170.926 74.043Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M168.251 83.6038L169.458 86.5097C169.528 86.491 169.601 86.468 169.674 86.4376C170.485 86.1009 170.872 85.1718 170.534 84.3576C170.197 83.5464 169.266 83.1646 168.455 83.5012C168.382 83.5317 168.314 83.567 168.251 83.6038Z",
    fill: "#CB705D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M175.758 82.1899C176.095 83.0016 177.026 83.3859 177.837 83.0492C178.649 82.712 179.033 81.7815 178.697 80.9698C178.36 80.158 177.428 79.7733 176.617 80.1104C175.805 80.4471 175.421 81.3781 175.758 82.1899Z",
    fill: "#CB705D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M178.725 76.8242L180.25 80.4982C180.25 80.4982 178.253 79.8081 177.234 77.2404L178.725 76.8242Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M163.311 76.2895C166.249 72.4286 171.895 74.4673 171.895 74.4673C171.895 74.4673 171.685 79.5448 180.944 78.9691C182.468 78.8744 185.06 80.4223 186.396 81.369C186.396 81.369 182.495 76.9859 180.56 73.9063C178.621 70.8252 175.89 72.5596 175.89 72.5596C175.89 72.5596 172.296 68.9406 167.371 71.0102C163.959 72.4438 163.311 76.2895 163.311 76.2895Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M169.506 83.4503C169.718 83.9622 170.115 84.2807 170.395 84.1644C170.678 84.0466 170.733 83.5411 170.52 83.0292C170.459 82.881 170.382 82.7505 170.296 82.643L169.427 82.5586C169.342 82.7824 169.367 83.1151 169.506 83.4503Z",
    fill: "#121D30"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M168.907 80.0891C168.568 79.2445 168.112 79.0585 167.596 79.9895L168.907 80.0891Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M175.044 77.2425C174.221 76.8548 173.759 77.0295 174.017 78.0626L175.044 77.2425Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M174.831 81.2393C175.043 81.7511 175.44 82.0697 175.72 81.9533C176 81.837 176.058 81.3301 175.845 80.8182C175.674 80.4059 175.377 80.1183 175.123 80.0879L175.119 80.0894L174.727 80.8977C174.749 81.0052 174.782 81.1234 174.831 81.2393Z",
    fill: "#121D30"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M182.055 115.584L193.385 113.37L194.4 94.4182C194.625 91.6826 192.508 89.318 189.764 89.2424L181.122 89.0039L174.984 92.8599C172.859 94.1949 172.127 96.9452 173.306 99.16L182.055 115.584Z",
    fill: "#EDB837"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M175.085 87.2797C175.497 87.0549 175.378 86.4404 175.026 85.931C174.82 85.6346 174.544 85.3853 174.269 85.3151C173.931 85.2287 173.811 85.8186 173.901 86.3982C174.008 87.0814 174.361 87.6743 175.085 87.2797Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M173.88 86.2265L174.923 85.7937C174.732 85.5596 174.5 85.3745 174.27 85.3152C173.963 85.2371 173.837 85.7073 173.88 86.2265Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M169.212 129.264L174.988 113.371L180.838 113.597V113.599C180.484 117.938 178.932 122.094 176.355 125.603L171.221 131.891L169.212 129.264Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M178.633 116.75C180.231 116.38 181.227 114.785 180.857 113.187L177.53 98.809C177.161 97.2111 175.565 96.2153 173.967 96.5848C172.369 96.9544 171.373 98.5499 171.743 100.148L175.368 115.222C175.368 115.222 177.035 117.12 178.633 116.75Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M196.912 113.138C198.482 112.662 199.368 111.003 198.892 109.434L194.641 94.7676C194.165 93.1976 192.506 92.3107 190.936 92.7868C189.367 93.2629 188.48 94.9212 188.956 96.4912L193.167 110.604C193.522 111.74 194.367 112.685 195.493 113.066C195.95 113.22 196.441 113.281 196.912 113.138Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M170.863 105.378L175.98 102.848L182.266 102.35L176.818 104.865L170.863 105.378Z",
    fill: "#EDB837"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M170.548 99.7504L172.549 107.004L181.325 104.703L174.984 92.8594L172.843 94.1109C170.888 95.2534 169.946 97.5679 170.548 99.7504Z",
    fill: "#EDB837"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M170.863 105.379L176.818 104.865L177.525 107.661L171.699 108.189L170.863 105.379Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M177.505 96.2968L174.453 91.2531L183.317 86.5215L185.066 93.1568L177.505 96.2968Z",
    fill: "#EDB837"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M183.907 91.2311C184.004 92.1543 184.096 93.3012 184.118 94.4997C184.184 98.1285 183.596 100.573 182.417 101.569C182.18 101.769 181.937 101.866 181.674 101.866C180.606 101.866 179.135 100.271 177.53 97.3742C177.063 96.533 176.644 95.6869 176.3 94.9517C177.133 95.6148 178.061 95.973 179.004 95.973C181.206 95.973 183.014 94.1694 183.907 91.2311ZM183.993 89.082C183.407 93.3871 181.25 95.6049 179.004 95.6049C177.571 95.6049 176.102 94.7009 174.983 92.859C174.983 92.859 178.677 102.234 181.674 102.234C182.012 102.234 182.341 102.115 182.655 101.85C185.753 99.2313 183.993 89.082 183.993 89.082Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M177.226 185.354H171.237L173.676 166.83H179.665L177.226 185.354Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M177.796 185.326H171.052L172.131 176.512L178.812 177.023L177.796 185.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M178.322 190.828H163.022L163.422 189.462C163.554 189.016 163.751 188.602 164.002 188.228C164.534 187.433 165.312 186.82 166.239 186.494L166.653 186.348C167.059 186.205 167.44 186.016 167.794 185.789C168.098 185.592 168.38 185.37 168.634 185.118C169.19 184.577 169.628 183.914 169.91 183.166H178.506L178.364 188.228L178.322 190.828Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M172.446 184.029H169.423",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M171.666 185.082H168.644",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M175.451 187.146C175.458 187.353 175.296 187.519 175.09 187.519C174.884 187.519 174.712 187.353 174.705 187.146C174.699 186.94 174.86 186.773 175.066 186.773C175.273 186.773 175.445 186.94 175.451 187.146Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M173.626 187.146C173.632 187.353 173.471 187.519 173.265 187.519C173.059 187.519 172.886 187.353 172.88 187.146C172.874 186.94 173.035 186.773 173.241 186.773C173.447 186.773 173.619 186.94 173.626 187.146Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M178.322 190.828H163.022L163.422 189.462C163.554 189.016 163.751 188.602 164.002 188.229H178.364L178.322 190.828Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M178.405 189.527H168.783",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M171.609 190.828H163.022L163.422 189.462C163.554 189.016 163.751 188.603 164.002 188.229C164.534 187.433 165.312 186.821 166.239 186.494L166.653 186.349C167.059 186.205 167.44 186.017 167.794 185.789C169.785 186.71 171.268 188.59 171.609 190.828Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M169.91 183.166L169.714 182.405C169.575 181.869 169.967 181.359 170.516 181.359H171.283C171.888 181.359 172.461 181.667 172.805 182.176L173.474 183.166H169.91Z",
    fill: "#2E363D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M194.995 113.325L178.478 112.43L179.925 116.615L193.675 116.466L194.995 113.325Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M179.925 116.614C179.925 116.614 174.267 121.844 173.932 131.174H199.233C199.233 122.406 193.675 116.465 193.675 116.465L179.925 116.614Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M194.484 120.121H190.517C190.517 120.121 192.475 124.638 196.378 124.935",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M177.218 120.121H179.405C179.405 120.121 178.569 124.397 175.019 124.935",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M184.632 116.896L185.014 123.82C185.014 123.82 186.299 123.137 186.025 120.833",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M189.252 117.332H192.854V115.901H189.252V117.332Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M180.497 117.332H181.75V115.901H180.497V117.332Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M182.576 117.332H188.251V115.901H182.576V117.332Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M183.639 117.619H186.066V115.612H183.639V117.619Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M200.41 185.343L194.42 185.612L191.357 165.51L197.347 165.24L200.41 185.343Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M200.755 185.327L194.018 185.63L192.854 176.471L199.58 176.876L200.755 185.327Z",
    fill: "#EDB837"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M202.068 190.828H186.768L186.902 189.462C186.947 189.016 187.064 188.602 187.241 188.228C187.618 187.433 188.278 186.82 189.14 186.494L189.527 186.348C189.906 186.205 190.25 186.016 190.559 185.789C190.825 185.592 191.064 185.37 191.269 185.118C191.72 184.577 192.029 183.914 192.165 183.166H200.762L201.604 188.228L202.068 190.828Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M194.869 184.029H191.847",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M194.294 185.082H191.271",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M198.481 187.146C198.528 187.353 198.398 187.519 198.192 187.519C197.986 187.519 197.782 187.353 197.735 187.146C197.688 186.94 197.818 186.773 198.024 186.773C198.23 186.773 198.434 186.94 198.481 187.146Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M196.655 187.146C196.702 187.353 196.572 187.519 196.366 187.519C196.16 187.519 195.956 187.353 195.909 187.146C195.862 186.94 195.992 186.773 196.197 186.773C196.404 186.773 196.609 186.94 196.655 187.146Z",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M202.068 190.828H186.768L186.902 189.462C186.947 189.016 187.064 188.602 187.241 188.229H201.603L202.068 190.828Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M192.164 189.529H201.785",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M195.354 190.828H186.768L186.902 189.462C186.947 189.016 187.064 188.603 187.241 188.229C187.618 187.433 188.278 186.821 189.14 186.494L189.527 186.349C189.906 186.205 190.25 186.017 190.559 185.789C192.73 186.71 194.578 188.59 195.354 190.828Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M192.165 183.166L191.821 182.405C191.579 181.869 191.871 181.359 192.421 181.359H193.187C193.792 181.359 194.425 181.667 194.868 182.176L195.73 183.166H192.165Z",
    fill: "#2E363D"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M186.02 130.725L182.414 174.568H169.888L173.968 130.903L186.02 130.725Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M197.25 150.818L201.66 174.569H189.134L185.198 150.997L197.25 150.818Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M197.25 150.818C197.25 150.818 199.232 137.8 199.223 131.107H186.697L185.198 150.997L197.25 150.818Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M195.242 91.9827L198.917 97.5221L189.673 103.6L185.601 89.1367L190.144 89.2005C192.199 89.2295 194.107 90.2704 195.242 91.9827Z",
    fill: "#EDB837"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M198.836 95.1816L188.392 101.676L189.455 104.9L200.367 97.6826L198.836 95.1816Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M175.105 105.754L175.627 100.906L173.736 99.1602",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M170.895 127.842L163.034 124.42C162.649 125.305 163.054 126.335 163.939 126.721L165.034 127.197L165.77 128.987C166.019 135.016 171.221 131.889 171.221 131.889L170.895 127.842Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M166.082 126.672L167.536 132.325C164.368 132.55 162.157 132.849 162.157 132.849C160.899 131.931 160.195 130.522 159.809 129.371L163.568 128.602C161.995 128.327 160.393 128.534 159.603 128.677C159.41 127.943 159.361 127.431 159.361 127.431C163.131 126.649 166.082 126.672 166.082 126.672Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M168.748 131.569C165.445 131.212 165.949 127.781 165.949 127.781L163.94 126.723",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M160.213 130.392C163.085 130.074 164.45 129.896 164.45 129.896",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M161.068 131.683L164.839 131.143",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M180.496 174.57L184.853 129.762H187.048",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M192.854 117.332C192.854 117.332 198.158 124.739 197.064 132.85C195.97 140.961 194.994 150.819 194.994 150.819L199.903 174.57",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M199.816 178.581L193.089 178.324",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M178.813 178.454L171.963 177.896",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M123.76 105.869L128.906 115.752H181.877C183.398 115.752 184.632 116.985 184.632 118.507V188.073C184.632 189.594 183.399 190.828 181.877 190.828H80.2835C78.7621 190.828 77.5283 189.594 77.5283 188.073V120.917V115.751V107.141C77.5283 105.62 78.7616 104.387 80.2835 104.387H121.316C122.343 104.387 123.285 104.958 123.76 105.869Z",
    fill: "#EDB837"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M82.3523 118.207C88.6954 118.207 93.8375 113.065 93.8375 106.721C93.8375 100.378 88.6954 95.2363 82.3523 95.2363C76.0093 95.2363 70.8672 100.378 70.8672 106.721C70.8672 113.065 76.0093 118.207 82.3523 118.207Z",
    fill: "#2E363D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M87.248 110.991L82.9767 106.72L87.248 102.449C87.4197 102.277 87.4197 101.996 87.248 101.824C87.0762 101.652 86.795 101.652 86.6232 101.824L82.352 106.095L78.0807 101.824C77.909 101.652 77.6277 101.652 77.456 101.824C77.2842 101.996 77.2842 102.277 77.456 102.449L81.7272 106.72L77.456 110.991C77.2842 111.163 77.2842 111.444 77.456 111.616C77.6277 111.788 77.909 111.788 78.0807 111.616L82.352 107.345L86.6232 111.616C86.795 111.788 87.0762 111.788 87.248 111.616C87.4197 111.444 87.4197 111.163 87.248 110.991Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M114.613 174.002C127.403 175.653 145.613 174.002 146.613 170.002",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M107.054 146.28C109.557 146.28 111.587 142.602 111.587 138.065C111.587 133.528 109.557 129.85 107.054 129.85C104.55 129.85 102.521 133.528 102.521 138.065C102.521 142.602 104.55 146.28 107.054 146.28Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M159.196 138.064C159.196 142.601 157.166 146.279 154.662 146.279C152.158 146.279 150.129 142.601 150.129 138.064C150.129 136.083 150.516 134.267 151.16 132.848C151.991 131.017 153.252 129.85 154.662 129.85C157.166 129.849 159.196 133.527 159.196 138.064Z",
    fill: "#121D30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M152.954 127.033C156.468 123.16 159.3 123.072 160.214 129.121L152.954 127.033Z",
    fill: "#121D30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M107.182 120.853C103.668 116.981 100.836 116.892 99.9229 122.941L107.182 120.853Z",
    fill: "#121D30"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M185.209 118.298C182.492 117.598 180.38 115.604 180.38 115.604L177.641 119.991C181.687 122.823 184.235 122.28 185.643 121.737L185.209 118.298Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M180.38 115.605C180.38 115.605 177.93 114.746 175.84 115.475L174.761 118.375C174.761 118.375 177.025 118.221 178.251 119.015C178.251 119.015 175.825 118.867 174.682 119.614L175.154 120.415C175.154 120.415 177.379 120.038 179.468 120.894L180.38 115.605Z",
    fill: "#D28A7B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M175.584 116.22C175.584 116.22 177.844 116.073 179.426 116.426",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M175.143 117.348C175.143 117.348 177.17 117.072 179.046 117.697",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M192.95 109.873L184.015 119.354L185.324 121.85C190.753 119.935 195.781 116.503 198.664 111.706L192.95 109.873Z",
    fill: "#D28A7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M176.564 99.1602C173.719 108.006 175.255 109.898 180.953 110.024L176.564 99.1602Z",
    fill: "#EDB837"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M192.755 109.873L196.628 110.777",
    stroke: "#121D30",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M18.4209 190.828H206.804",
    stroke: "#121D30",
    strokeMiterlimit: 10
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartFinderNoProductTypes);
export default __webpack_public_path__ + "static/media/partFinderNoProductTypes.3da3d5b285bb4dc9f94f86fc13bc1749.svg";
export { ForwardRef as ReactComponent };